import { DateRange, getWeekNumber } from 'owa-datetime-utils';
import {
    DateRangeType,
    FirstWeekOfYear,
} from '@fluentui/date-time-utilities/lib/dateValues/dateValues';
import {
    endOfWeek,
    formatDateInterval,
    formatMonthDayYear,
    formatShortWeekDayMonthDayYear,
    formatYearMonth,
} from 'owa-datetime';

/**
 * Formats the dates in a given DateRange, according to the type of the range.
 */
export default function dateRangeToDisplayString(
    dateRange: DateRange,
    dateRangeType: DateRangeType,
    firstDayOfWeek?: number,
    showWeekNumbers?: boolean,
    firstWeekOfYear?: FirstWeekOfYear,
    useWeekDay?: boolean,
    numOfDaysInDayRange?: number
) {
    let start = dateRange.start;
    let end = dateRange.end;

    let weekNumber =
        showWeekNumbers &&
        (dateRangeType == DateRangeType.Week || dateRangeType == DateRangeType.WorkWeek)
            ? getWeekNumber(endOfWeek(end, firstDayOfWeek), firstDayOfWeek, firstWeekOfYear)
            : undefined;

    let effectiveDateRangeType =
        dateRangeType === DateRangeType.WorkWeek ||
        (dateRangeType === DateRangeType.Day && numOfDaysInDayRange && numOfDaysInDayRange > 1)
            ? DateRangeType.Week
            : dateRangeType;

    let formatDayFunction = useWeekDay ? formatShortWeekDayMonthDayYear : formatMonthDayYear;

    let dateString = [formatDayFunction, formatDateInterval, formatYearMonth][
        effectiveDateRangeType
    ](start, end, weekNumber);

    return dateString;
}
